"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var main_1 = require("../../../reducers/slices/main");
var user_1 = require("../../../reducers/slices/user");
var send_otp_1 = require("../../../api/calls/otp/send_otp");
var functions_1 = require("../../../constants/functions");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_router_dom_1 = require("react-router-dom");
var validate_reference_1 = require("../../../api/calls/referral/validate_reference");
var SignUpPage = function () {
    var _a, _b, _c, _d;
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _e = (0, react_1.useState)(""), nameMessage = _e[0], setNameMessage = _e[1];
    var _f = (0, react_1.useState)(""), surnameMessage = _f[0], setSurnameMessage = _f[1];
    var _g = (0, react_1.useState)(""), emailMessage = _g[0], setEmailMessage = _g[1];
    var _h = (0, react_1.useState)(""), phoneMessage = _h[0], setPhoneMessage = _h[1];
    var _j = (0, react_1.useState)(""), referralInputMessage = _j[0], setReferralInputMessage = _j[1];
    var _k = (0, react_1.useState)(""), passwordMessage = _k[0], setPasswordMessage = _k[1];
    var _l = (0, react_1.useState)(""), confirmPasswordMessage = _l[0], setConfirmPasswordMessage = _l[1];
    var _m = (0, react_1.useState)(""), birthdayMessage = _m[0], setBirthdayMessage = _m[1];
    var _o = (0, react_1.useState)(""), agreesMessage = _o[0], setAgreesMessage = _o[1];
    //
    var _p = (0, react_1.useState)(""), otpMessage = _p[0], setOTPMessage = _p[1];
    var _q = (0, react_1.useState)(""), generatedOTP = _q[0], setGeneratedOTP = _q[1];
    var _r = (0, react_1.useState)(""), enteredOTP = _r[0], setEnteredOTP = _r[1];
    var _s = (0, react_1.useState)(0), otpCountdown = _s[0], setOTPCountdown = _s[1];
    var _t = (0, react_1.useState)(null), timer = _t[0], setTimer = _t[1];
    var maxCOTPCountdown = parseInt((_a = process.env.OTP_COUNTDOWN) !== null && _a !== void 0 ? _a : "30");
    var _u = (0, react_1.useState)(""), referralInput = _u[0], setReferralInput = _u[1];
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var onControlChanged = function (name, value) {
        var _a;
        dispatch((0, user_1.setUser)(__assign(__assign({}, user), (_a = {}, _a[name] = value, _a))));
    };
    var setReferralValue = function (value) {
        setReferralInput(value);
        setReferralInputMessage("");
        onControlChanged("referralCode", value);
    };
    (0, react_1.useEffect)(function () {
        var _a;
        var referral = (_a = searchParams.get("referral_code")) !== null && _a !== void 0 ? _a : searchParams.get("code");
        if (referral) {
            setReferralValue(referral);
        }
        return function () {
            if (timer) {
                // console.log("clearing timer");
                clearTimeout(timer);
            }
        };
    }, []);
    var validate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var messageCount, isValidPhoneNumber, isValidReferralCode;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    messageCount = 0;
                    setNameMessage("");
                    setSurnameMessage("");
                    setEmailMessage("");
                    setPhoneMessage("");
                    setPasswordMessage("");
                    setConfirmPasswordMessage("");
                    setBirthdayMessage("");
                    setAgreesMessage("");
                    if (!user.name) {
                        messageCount++;
                        setNameMessage("Name is required.");
                    }
                    if (!user.surname) {
                        messageCount++;
                        setSurnameMessage("Surname is required.");
                    }
                    if (!user.email) {
                        messageCount++;
                        setEmailMessage("Email is required.");
                    }
                    if (!((_a = user.cell_number) === null || _a === void 0 ? void 0 : _a.phone_number)) {
                        messageCount++;
                        setPhoneMessage("Cell Number is required.");
                    }
                    if ((_b = user === null || user === void 0 ? void 0 : user.cell_number) === null || _b === void 0 ? void 0 : _b.phone_number) {
                        isValidPhoneNumber = doshx_controls_web_1.Utilities.isValidPhoneNumber((_c = user === null || user === void 0 ? void 0 : user.cell_number) === null || _c === void 0 ? void 0 : _c.phone_number, (_d = user === null || user === void 0 ? void 0 : user.cell_number) === null || _d === void 0 ? void 0 : _d.country_abbreviation);
                        if (!isValidPhoneNumber) {
                            messageCount++;
                            setPhoneMessage("Invalid Cell Number.");
                        }
                    }
                    if (!referralInput) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, validate_reference_1.verifyReferralCode)(referralInput)];
                case 1:
                    isValidReferralCode = _e.sent();
                    if (!isValidReferralCode) {
                        messageCount++;
                        setReferralInputMessage("Invalid Code.");
                    }
                    _e.label = 2;
                case 2:
                    if (!user.password) {
                        messageCount++;
                        setPasswordMessage("Password is required.");
                    }
                    if (!user.confirm_password) {
                        messageCount++;
                        setConfirmPasswordMessage("Confirm Password is required.");
                    }
                    else {
                        if (user.password != user.confirm_password) {
                            messageCount++;
                            setConfirmPasswordMessage("Passwords don't match.");
                        }
                    }
                    // if (!user.birthday) {
                    //   messageCount++;
                    //   setBirthdayMessage("Birthday is required.");
                    // }
                    if (!user.agrees_terms_and_conditions) {
                        messageCount++;
                        setAgreesMessage("Must agree to our terms and conditions.");
                    }
                    return [2 /*return*/, messageCount ? false : true];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "flex flex-col justify-center h-full overflow-y-auto w-96" }, generatedOTP ? (react_1.default.createElement("div", { className: "flex flex-col overflow-auto gap-y-4" },
        react_1.default.createElement("div", { className: "text-3xl font-bold" }, "Verify Phone Number"),
        react_1.default.createElement("div", { className: "flex flex-col w-full gap-4" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Enter OTP", type: "number", value: enteredOTP, size: "small", errorText: otpMessage, textColor: "text-black", labelColor: "text-black", borderColor: "border-borders", onChange: function (v) { return setEnteredOTP(v); } }),
            otpCountdown > 0 ? (react_1.default.createElement("div", { className: "w-10" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: otpCountdown.toString(), size: "small", backgroundColor: "bg-success" }))) : (react_1.default.createElement("div", { className: "w-full" },
                react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Resend OTP", icon: pro_solid_svg_icons_1.faSend, textColor: "text-primary", iconColor: "text-primary", size: "small", onClick: function () {
                        var otp = doshx_controls_web_1.Utilities.generateOTP();
                        (0, send_otp_1.sendOTP)({
                            otp: otp,
                            phone: (0, functions_1.formatNumberForSms)(user === null || user === void 0 ? void 0 : user.cell_number),
                        }).then(function (response) {
                            if (response.eventId) {
                                //If dev, auto populate OTP
                                if (process.env.ENVIRONMENT == "DEV") {
                                    setEnteredOTP(otp);
                                }
                                setGeneratedOTP(otp);
                                setOTPCountdown(maxCOTPCountdown);
                                var timeLeft_1 = maxCOTPCountdown;
                                if (timer) {
                                    // console.log("clearing timer");
                                    clearTimeout(timer);
                                }
                                setTimer(setInterval(function () {
                                    timeLeft_1 = timeLeft_1 - 1;
                                    setOTPCountdown(timeLeft_1);
                                    if (timer && timeLeft_1 === 0) {
                                        // console.log("clearing timer");
                                        clearTimeout(timer);
                                    }
                                }, 1000));
                            }
                            else {
                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: response.message }));
                            }
                        });
                    } })))),
        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Create Account", backgroundColor: "bg-primary", loading: user === null || user === void 0 ? void 0 : user.is_loading, enabled: !(user === null || user === void 0 ? void 0 : user.is_loading), onClick: function () {
                if (enteredOTP === generatedOTP) {
                    dispatch((0, user_1.sign_up_thunk)());
                }
                else {
                    setOTPMessage("Invalid OTP entered");
                }
            } }))) : (react_1.default.createElement("div", { className: "flex flex-col overflow-auto gap-y-4" },
        react_1.default.createElement("div", { className: "text-3xl font-bold" }, "Create your account"),
        react_1.default.createElement("div", { className: "flex flex-col gap-y-4" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Name", value: user === null || user === void 0 ? void 0 : user.name, errorText: nameMessage, onChange: function (v) { return onControlChanged("name", v); } }),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Surname", value: user === null || user === void 0 ? void 0 : user.surname, errorText: surnameMessage, onChange: function (v) { return onControlChanged("surname", v); } }),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", value: user === null || user === void 0 ? void 0 : user.email, errorText: emailMessage, onChange: function (v) { return onControlChanged("email", v); } }),
            react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Cell Number", value: (_b = user === null || user === void 0 ? void 0 : user.cell_number) === null || _b === void 0 ? void 0 : _b.phone_number, size: "small", errorText: phoneMessage, defaultCountryCode: (_d = (_c = user === null || user === void 0 ? void 0 : user.cell_number) === null || _c === void 0 ? void 0 : _c.country_abbreviation) !== null && _d !== void 0 ? _d : "BW", showExtension: true, showFlag: true, onChange: function (v) {
                    var _a, _b;
                    return onControlChanged("cell_number", {
                        country_code: (_a = user === null || user === void 0 ? void 0 : user.cell_number) === null || _a === void 0 ? void 0 : _a.country_code,
                        country_abbreviation: (_b = user === null || user === void 0 ? void 0 : user.cell_number) === null || _b === void 0 ? void 0 : _b.country_abbreviation,
                        phone_number: v,
                    });
                }, onExtensionChange: function (ext, code) { return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        onControlChanged("cell_number", { country_code: ext, country_abbreviation: code, phone_number: (_a = user === null || user === void 0 ? void 0 : user.cell_number) === null || _a === void 0 ? void 0 : _a.phone_number });
                        return [2 /*return*/];
                    });
                }); }, international: true }),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Referral Code", value: referralInput, errorText: referralInputMessage, onChange: function (v) { return setReferralValue(v); } }),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Password", value: user === null || user === void 0 ? void 0 : user.password, errorText: passwordMessage, type: "password", onChange: function (v) { return onControlChanged("password", v); } }),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Confirm Password", value: user === null || user === void 0 ? void 0 : user.confirm_password, errorText: confirmPasswordMessage, type: "password", onChange: function (v) { return onControlChanged("confirm_password", v); } })),
        react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "I have read and agree to the Terms of Service", errorText: agreesMessage, onChange: function (v) { return onControlChanged("agrees_terms_and_conditions", v); } }),
        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", backgroundColor: "bg-primary", loading: user === null || user === void 0 ? void 0 : user.is_loading, enabled: !(user === null || user === void 0 ? void 0 : user.is_loading), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                var otp_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, validate()];
                        case 1:
                            if (_a.sent()) {
                                otp_1 = doshx_controls_web_1.Utilities.generateOTP();
                                (0, send_otp_1.sendOTP)({
                                    otp: otp_1,
                                    phone: (0, functions_1.formatNumberForSms)(user === null || user === void 0 ? void 0 : user.cell_number),
                                }).then(function (response) {
                                    if (response.eventId) {
                                        //If dev, auto populate OTP
                                        if (process.env.ENVIRONMENT == "DEV") {
                                            setEnteredOTP(otp_1);
                                        }
                                        setGeneratedOTP(otp_1);
                                        setOTPCountdown(maxCOTPCountdown);
                                        var timeLeft_2 = maxCOTPCountdown;
                                        if (timer) {
                                            // console.log("clearing timer");
                                            clearTimeout(timer);
                                        }
                                        setTimer(setInterval(function () {
                                            timeLeft_2 = timeLeft_2 - 1;
                                            setOTPCountdown(timeLeft_2);
                                            if (timer && timeLeft_2 === 0) {
                                                // console.log("clearing timer");
                                                clearTimeout(timer);
                                            }
                                        }, 1000));
                                    }
                                    else {
                                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: response.message }));
                                    }
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            }); } }),
        react_1.default.createElement("div", { className: "text-center" },
            "Already have an account?",
            " ",
            react_1.default.createElement("span", { className: "cursor-pointer hover:underline text-primary", onClick: function () {
                    dispatch((0, main_1.setDrawerPage)("login"));
                    // navigate(`${rootPath}/login`);
                } }, "Sign in"))))));
};
exports.SignUpPage = SignUpPage;
